import { Avatar, Button, Card } from "react-dsgov";
import { useNavigate } from 'react-router-dom';
import IApi from "../../../interfaces/IApi";
import styles from './CardApi.module.scss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from "react";
import classNames from "classnames";
import { isPortalInteroperabilidade } from "../../../config/portalMode";

export interface ICardApiProps {
    api: IApi;
}

const CardApi: React.FC<ICardApiProps> = ({ api }) => {
    const navigate = useNavigate();

    const [linkApi] = useState(`/catalogo-apis/${api.idRotina}`);

    const copiarLink = () => {
        navigator.clipboard.writeText(`${window.location.origin}${linkApi}`);
        toast.info(`Endereço da API "${api.nome}" copiado para a Área de Trabalho`);
    }

    return (
        <Card className={classNames(styles["card-api"])} key={api.idRotina} hover>
            <Card.Header
                cardTitle={api.nome}
                cardSubtitle={api.subtitulo}
                cardCustomAvatar={api.icone ? (
                    <div className={styles["avatar-api"]}>
                        <Avatar icon={api.icone} bgColor={api.cor || "#1351b4"} iconColor="#FFFFFF" />
                    </div>
                ) : undefined}
            />
            <Card.Content>
                {api.tecnologia && (
                    <div className={styles["tecnologia"]}>
                        <b>Tecnologia: </b> {api.tecnologia}
                    </div>
                )}
                {api.publicoAlvo && (
                    <div className={styles["publico-alvo"]}>
                        <b>Público-alvo: </b> {api.publicoAlvo}
                    </div>
                )}
                    {api.siglaSolucao && (
                        <div className={styles["solucao"]}>
                            <b>Solução: </b> {api.siglaSolucao}
                        </div>
                    )}
                {api.tags && (
                    <div className={styles["tags"]}>
                        {api.tags.split(/[\s,;|]+/).filter(t => t).map((tag, index) => (
                            <span key={index}>#{tag}</span>
                        ))}
                    </div>
                )}
            </Card.Content>
            <Card.Footer>
                <div className="d-flex">
                    <div>
                        <Button onClick={() => navigate(linkApi)} primary>Detalhes</Button>
                    </div>
                    <div className="ml-auto">
                        {!isPortalInteroperabilidade() && (
                            <Button onClick={copiarLink} circle aria-label="Compartilhar" icon="fas fa-share-alt" />
                        )}
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );
}

export default CardApi;
